<template>
  <div class="uk-card-small uk-card-default uk-margin-top uk-text-small">
    <div class="uk-card-header">
      <h3 class="uk-card-title">Containers</h3>
    </div>
    <div class="uk-card-body">
      <table
        class="uk-table uk-table-striped uk-table-small"
        v-if="!isDropAndHook"
      >
        <thead>
          <th>Container Number</th>
          <th>Length</th>
          <th>Type</th>
          <th>Seal Number</th>
          <th v-if="!settingsOrderLtlEnabled">Cargo Pieces</th>
          <th v-if="isRailPickUp">Pick-Up #</th>
          <th v-else-if="isRailDropOff">Release #</th>
          <th v-if="!settingsOrderLtlEnabled">Cargo Description</th>
          <th v-if="!settingsOrderLtlEnabled">Weight</th>
        </thead>
        <!-- <tbody v-if="shouldShowContainers"> -->
        <tbody
          v-for="(container, containerIdx) in orderData.containers"
          :key="containerIdx"
        >
          <tr>
            <td
              v-if="!container.isAdded"
              class="uk-padding-remove-left uk-padding-remove-right"
            >
              {{ container.containerId }}
            </td>
            <td v-else class="uk-padding-remove-left uk-padding-remove-right">
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                placeholder="Container Num"
                :value="
                  container.containerId && container.containerId.toUpperCase()
                "
                @input="
                  container.containerId = $event.target.value.toUpperCase()
                "
              />
            </td>
            <td>
              <div v-if="container.sizeType">{{ container.sizeType }}</div>
              <FilterSelector
                v-else
                v-model="container.size"
                :options="containerSizes"
                class="uk-form-width-small uk-padding-remove-left uk-padding-remove-right"
                :clearable="false"
                :showLabels="false"
              ></FilterSelector>
            </td>
            <td v-if="container.sizeType">{{ container.sizeType }}</td>
            <td v-else>
              <FilterSelector
                v-model="container.type"
                :clearable="false"
                :options="containerTypesValues"
                class="uk-form-width-small uk-padding-remove-left uk-padding-remove-right"
              ></FilterSelector>
            </td>

            <td class="uk-padding-remove-left uk-padding-remove-right">
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                placeholder="Seal Number"
                v-model="container.sealNumber"
              />
            </td>
            <td
              class="uk-padding-remove-left uk-padding-remove-right"
              v-if="!settingsOrderLtlEnabled"
            >
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                placeholder="Cargo Pieces"
                v-model="container.freightContents[0].quantity"
              />
            </td>
            <td
              class="uk-padding-remove-left uk-padding-remove-right"
              v-if="isRailPickUp"
            >
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                v-model="container.pickupNumber"
                placeholder="Pick-Up #"
              />
            </td>
            <td
              class="uk-padding-remove-left uk-padding-remove-right"
              v-else-if="isRailDropOff"
            >
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                v-model="container.releaseNumber"
                placeholder="Release #"
              />
            </td>
            <td
              class="uk-padding-remove-left uk-padding-remove-right"
              v-if="!settingsOrderLtlEnabled"
            >
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                v-model="container.freightContents[0].description"
                placeholder="Description"
              />
            </td>
            <td
              class="uk-padding-remove-left uk-padding-remove-right"
              v-if="!settingsOrderLtlEnabled"
            >
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                v-model="container.freightContents[0].weight"
                placeholder="Weight (lbs)"
              />
            </td>
            <td uk-tooltip="Remove container">
              <span
                @click="removeContainer(containerIdx)"
                uk-icon="minus-circle"
              ></span>
            </td>
          </tr>

          <!-- AHHHHHHHHHHHHHHHH -->
          <tr v-if="settingsOrderLtlEnabled">
            <td colspan="8" align="center">
              <div>
                <table
                  class="uk-table uk-width-1-1 clr-storm-6 uk-table-striped uk-table-hover uk-table-divider"
                >
                  <thead>
                    <!-- <th class="uk-table-shrink">#</th> -->
                    <th>Qty</th>
                    <th>Packing Type</th>
                    <th>Is Hazmat</th>
                    <th>Weight (lbs)</th>
                    <th>Description</th>
                    <th>NMFC #</th>
                    <th>NMFC Class</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(freightContent,
                      freightContentIdx) in container.freightContents"
                      :key="freightContentIdx"
                    >
                      <td>
                        <InputField
                          v-model="freightContent.quantity"
                          id="Quantity"
                        ></InputField>
                      </td>
                      <td>
                        <InputField
                          v-model="freightContent.packingType"
                          id="PackingType"
                        ></InputField>
                      </td>
                      <td>
                        <InputField
                          type="checkbox"
                          v-model="freightContent.isHazmat"
                          id="IsHazmat"
                        ></InputField>
                      </td>
                      <td>
                        <InputField
                          v-model="freightContent.weight"
                          id="Weight"
                        ></InputField>
                      </td>
                      <td>
                        <InputField
                          v-model="freightContent.description"
                          id="Description"
                          type="textarea"
                        ></InputField>
                      </td>
                      <td>
                        <InputField
                          v-model="freightContent.nmfcNumber"
                          id="NMFCNumber"
                        ></InputField>
                      </td>
                      <td>
                        <InputField
                          v-model="freightContent.nmfcClass"
                          id="nmfcClass"
                        ></InputField>
                      </td>
                      <td uk-tooltip="Remove freight content">
                        <span
                          @click="
                            removeFreightContents(
                              containerIdx,
                              freightContentIdx,
                            )
                          "
                          uk-icon="icon: minus-circle; ratio: 1.5"
                        ></span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" align="left">
                        <button
                          @click="addFreightContents(containerIdx)"
                          class="uk-button uk-button-secondary uk-width-3-6"
                        >
                          <span uk-icon="plus-circle"></span> Freight Content
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody class="uk-margin" v-if="!isDropAndHook">
          <tr>
            <td colspan="1" align="left">
              <button
                @click="addContainer"
                class="uk-button uk-button-secondary uk-width-3-6"
              >
                <span uk-icon="plus-circle"></span> Container
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        class="uk-table uk-table-striped uk-table-small"
        v-if="isDropAndHook"
      >
        <thead>
          <th>Load Type</th>
          <th>Container Number</th>
          <th>Length</th>
          <th>Type</th>
          <th>Seal Number</th>
          <th>Cargo Pieces</th>
          <th>Cargo Description</th>
          <th>Weight</th>
        </thead>
        <tr
          v-for="(container, containerIdx) in orderData.containers"
          :key="containerIdx"
        >
          <td>{{ strForContainerLoadType(container.loadType) }}</td>
          <td
            v-if="!container.isAdded"
            class="uk-padding-remove-left uk-padding-remove-right"
          >
            {{ container.containerId }}
          </td>
          <td v-else class="uk-padding-remove-left uk-padding-remove-right">
            <input
              type="text"
              class="uk-input uk-form-small uk-form-width-small"
              placeholder="Container Num"
              :value="
                container.containerId && container.containerId.toUpperCase()
              "
              @input="container.containerId = $event.target.value.toUpperCase()"
            />
          </td>
          <td>
            <div v-if="container.sizeType">{{ container.sizeType }}</div>
            <FilterSelector
              v-else
              v-model="container.size"
              :options="containerSizes"
              class="uk-form-width-small uk-padding-remove-left uk-padding-remove-right"
              :clearable="false"
              :showLabels="false"
            ></FilterSelector>
          </td>
          <td v-if="container.sizeType">{{ container.sizeType }}</td>
          <td v-else>
            <FilterSelector
              v-model="container.type"
              :clearable="false"
              :options="containerTypesValues"
              class="uk-form-width-small uk-padding-remove-left uk-padding-remove-right"
            ></FilterSelector>
          </td>

          <td class="uk-padding-remove-left uk-padding-remove-right">
            <input
              type="text"
              class="uk-input uk-form-small uk-form-width-small"
              placeholder="Seal Number"
              v-model="container.sealNumber"
            />
          </td>
          <td class="uk-padding-remove-left uk-padding-remove-right">
            <input
              type="text"
              class="uk-input uk-form-small uk-form-width-small"
              placeholder="Cargo Pieces"
              v-model="container.freightContents[0].quantity"
            />
          </td>
          <td class="uk-padding-remove-left uk-padding-remove-right">
            <input
              type="text"
              class="uk-input uk-form-small uk-form-width-small"
              v-model="container.freightContents[0].description"
              placeholder="Description"
            />
          </td>
          <td class="uk-padding-remove-left uk-padding-remove-right">
            <input
              type="text"
              class="uk-input uk-form-small uk-form-width-small"
              v-model="container.freightContents[0].weight"
              placeholder="Weight (lbs)"
            />
          </td>
          <td uk-tooltip="Remove container">
            <span
              @click="removeContainer(containerIdx)"
              uk-icon="minus-circle"
            ></span>
          </td>
        </tr>
        <button
          v-if="orderData.containers.length === 0"
          @click="addDropHookContainer"
          class="uk-button uk-button-secondary"
        >
          <span uk-icon="plus-circle"></span> Container
        </button>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ORDER_TYPE } from '../../../types';
import FilterSelector from '../../core/FilterSelector.vue';
import { containerSizeTypeMixin } from '../../../utils/container';

export default defineComponent({
  props: {
    orderData: Object,
    activeContainersWithoutOrder: Array,
    settingsOrderLtlEnabled: Boolean,
    isOceanExport: {
      required: true,
    },
    isOceanImport: {
      required: true,
    },
    isLand: {
      required: true,
    },
    isRailPickUp: {
      default: false,
    },
    isRailDropOff: {
      default: false,
    },
  },
  components: {
    FilterSelector,
  },
  mixins: [containerSizeTypeMixin],
  computed: {
    shouldShowContainers(): boolean {
      return true;
    },
    isDropAndHook(): boolean {
      return (this as any).orderData.isDropAndHook;
    },
  },
  // watch: {
  //   orderData(val: any) {
  //     this.orderData.containers.map((x) => {
  //       x.containerId = x.containerId.toUpperCase();
  //       return x;
  //     });
  //   },
  // },
  methods: {
    removeContainer(containerIdx: number) {
      (this as any).orderData.containers.splice(containerIdx, 1);
    },
    strForContainerLoadType(loadType: string): string {
      if (loadType === 'EmptyOut') return 'Empty Out';
      if (loadType === 'EmptyIn') return 'Empty In';
      if (loadType === 'FullOut') return 'Full Out';
      else return 'Full In';
    },
    removeFreightContents(containerIdx: number, freightContentIdx: number) {
      (this as any).orderData.containers[containerIdx].freightContents.splice(
        freightContentIdx,
        1,
      );
    },
    addFreightContents(containerIdx: number) {
      (this as any).orderData.containers[containerIdx].freightContents.push({
        quantity: undefined,
        packingType: undefined,
        isHazmat: false,
        weight: undefined,
        description: undefined,
        nmfcNumber: undefined,
        nmfcClass: undefined,
      });
    },
    addContainer() {
      (this as any).orderData.containers.push({
        containerId: undefined,
        size: undefined,
        type: undefined,
        sealNumber: undefined,
        isAdded: true,
        freightContents: [
          {
            quantity: undefined,
            packingType: undefined,
            isHazmat: false,
            weight: undefined,
            description: undefined,
            nmfcNumber: undefined,
            nmfcClass: undefined,
          },
        ],
      });
    },
    addDropHookContainer() {
      const vm = (this as any);

      if (vm.isOceanExport) {
        vm.orderData.containers.push({
          containerId: undefined,
          size: undefined,
          type: undefined,
          sealNumber: undefined,
          isAdded: true,
          loadType: 'FullIn',
          freightContents: [
            {
              quantity: undefined,
              packingType: undefined,
              isHazmat: false,
              weight: undefined,
              description: undefined,
              nmfcNumber: undefined,
              nmfcClass: undefined,
            },
          ],
        });
        vm.orderData.containers.push({
          containerId: undefined,
          size: undefined,
          type: undefined,
          sealNumber: undefined,
          isAdded: true,
          loadType: 'EmptyOut',
          freightContents: [
            {
              quantity: undefined,
              packingType: undefined,
              isHazmat: false,
              weight: undefined,
              description: undefined,
              nmfcNumber: undefined,
              nmfcClass: undefined,
            },
          ],
        });
      } else {
        vm.orderData.containers.push({
          containerId: undefined,
          size: undefined,
          type: undefined,
          sealNumber: undefined,
          isAdded: true,
          loadType: 'FullOut',
          freightContents: [
            {
              quantity: undefined,
              packingType: undefined,
              isHazmat: false,
              weight: undefined,
              description: undefined,
              nmfcNumber: undefined,
              nmfcClass: undefined,
            },
          ],
        });
        vm.orderData.containers.push({
          containerId: undefined,
          size: undefined,
          type: undefined,
          sealNumber: undefined,
          isAdded: true,
          loadType: 'EmptyIn',
          freightContents: [
            {
              quantity: undefined,
              packingType: undefined,
              isHazmat: false,
              weight: undefined,
              description: undefined,
              nmfcNumber: undefined,
              nmfcClass: undefined,
            },
          ],
        });
      }
    },
  },
});
</script>
